import { render, staticRenderFns } from "./AdminClassroomsList.vue?vue&type=template&id=bc3d5970"
import script from "./AdminClassroomsList.vue?vue&type=script&lang=js"
export * from "./AdminClassroomsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports